import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import {RequireAuth} from "./components/require-auth";
import {RedirectIfAuth} from "./components/redirect-if-auth";
import {Dashboard} from "./pages/dashboard";
import {ErrorNotFound} from "./pages/errors/not-found";
import {LoginPage} from "./pages/login";
import {SettingsPage} from "./pages/settings";
import {ProxyPage} from "./pages/proxy";
import {BuildsPage} from "./pages/builds";
import {PoolPage} from "./pages/pool";

function App() {
  return (
      <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route element={<RequireAuth />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/pool" element={<PoolPage />} />
              <Route path="/proxy" element={<ProxyPage />} />
              <Route path="/builds" element={<BuildsPage />} />
              <Route path="/settings" element={<SettingsPage />} />
          </Route>
          <Route element={<RedirectIfAuth />}>
              <Route path="/login" element={<LoginPage />} />
          </Route>
          <Route path="*" element={<ErrorNotFound />} />
      </Routes>
  );
}

export default App;
